import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import "../App.css";

function ListWallet({ onSubmit, listChannels = null | [] }) {
  const handleClick = (data) => {
    onSubmit(data);
  };
  return (
    <div>
      <List dense sx={{ width: "100%", bgcolor: "background.paper" }}>
        {listChannels.map((channel) => {
          const labelId = `checkbox-list-secondary-label-${channel.index}`;
          return (
            <>
              <ListItem
                key={channel.index}
                onClick={() => handleClick(channel)}
              >
                <ListItemButton>
                  <ListItemAvatar>
                    <Avatar alt={channel.name} src={channel.logo} />
                  </ListItemAvatar>
                  <ListItemText id={labelId} primary={channel.name} />
                </ListItemButton>
              </ListItem>
              <Divider />
            </>
          );
        })}
      </List>
    </div>
  );
}

export default ListWallet;
